import { motion } from "framer-motion";

export default function BarChart({ title, data }) {
  const maxValue = Math.max(...data.map((d) => d.value));

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="glass-card rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-10 h-full"
    >
      <h3 className="text-base md:text-lg text-text-[#FD5B38] text-center mb-6 md:mb-10">
        {title}
      </h3>

      <div className="space-y-6 md:space-y-8 lg:space-y-10">
        {data.map((item, index) => (
          <div key={item.label} className="flex items-center gap-4 md:gap-6">
            <div className="flex items-center gap-2 w-28 md:w-32 flex-shrink-0">
              <div
                className="w-4 h-4 rounded-full flex-shrink-0"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-sm md:text-base text-text-secondary">
                {item.label}
              </span>
            </div>

            <div className="flex-1 flex items-center gap-4 md:gap-6">
              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: `${(item.value / maxValue) * 100}%` }}
                viewport={{ once: true }}
                transition={{
                  duration: 1,
                  delay: 0.1 * index,
                  ease: [0.22, 1, 0.36, 1],
                }}
                className="h-4 rounded-sm"
                style={{ backgroundColor: item.color }}
              />

              <span className="text-sm md:text-base text-text-[#FD5B38] font-normal w-12 text-right flex-shrink-0">
                {item.value}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
